import React from "react"
import "../../styles/ContentTestPage/contentTestPage.scss"
import { TestContext } from "../../components/TestContext"

/** View */
import Paragraph from "../../components/Paragraph"
import Button from "../../components/Button"

/** Image */
const age = require("../../../static/images/18.svg") as string

export const ContentTestPage = () => {
  return (
    <TestContext.Consumer>
      {({ clickAnswer, activeQuestion, questions }) => {
        return (
          <div className={"test__wrapper"}>
            <div className={"test__container"}>
              <div className={"test__top"}>
                <div className={"test__block"}>
                  <img
                    className={"test__image"}
                    src={
                      questions[activeQuestion] &&
                      questions[activeQuestion].image
                    }
                    alt={"Бекграунд"}
                  />
                </div>

                <p className={"test__triangle-text"}>
                  {activeQuestion + 1}/
                  {questions.length > 0 && questions.length}
                </p>

                <div className={"insert-container share"}>
                  <Paragraph
                    classes={"test__question"}
                    text={
                      questions[activeQuestion] &&
                      questions[activeQuestion].question
                    }
                  />

                  <div className={"test__buttons"}>
                    {questions.length > 0 &&
                      questions[activeQuestion].answers.map(
                        (item: any, index: any) => {
                          return (
                            <div
                              key={index}
                              className={"test__buttons-link"}
                              onClick={() => clickAnswer(item)}
                            >
                              <Button
                                className={"test__buttons-name animation-other"}
                                name={item ? "Да" : "Нет"}
                              />
                            </div>
                          )
                        }
                      )}
                  </div>
                </div>
              </div>

              <div className={"test__bottom"}>
                <div className={"test__buttons-imageBlock"}>
                  <img
                    src={age}
                    alt="Ограничение по возрасту"
                    className={"test__buttons-image"}
                  />
                </div>

                <a
                  href={"/Правила акции.pdf"}
                  target={"_blank"}
                  className={"test__buttons-text"}
                >
                  <b>
                    <u>Правила акции.</u>
                  </b>{" "}
                  Срок проведения акции: с 20 января по 15 февраля 2020 года.
                </a>
              </div>
            </div>
          </div>
        )
      }}
    </TestContext.Consumer>
  )
}

export default ContentTestPage
